import {
  FOOTER_POP_UP_CLOSE,
  GET_INVOICES,
  SELECTED_INVOICES,
  SELECTED_NSF_INVOICES,
} from "./action";

const initialState = {
  popUp: false,
  selectedInvoice: [],
  selectedNsfInvoice: [],
};

const invoiceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FOOTER_POP_UP_CLOSE:
      return {
        ...state,
        popUp: payload,
      };

    case SELECTED_INVOICES:
      let currentSelectedInvoices = payload.map((i) => {
        return {
          _id: i.original._id,
          invoiceCurrency: i.original.invoice_currency,
          invoiceTotalAmount:
            i &&
            i.original &&
            i.original.not_paid_amount &&
            i.original.not_paid_amount.value,
        };
      });
      return {
        ...state,
        selectedInvoice: currentSelectedInvoices,
      };

    case SELECTED_NSF_INVOICES:
      let currentNsfInvoice = payload.map((i) => {
        return {
          // _id: i.original._id,
          inv: i.original.inv,
          invoiceCurrency: i?.original?.paid_amount?.currency,
          invoiceTotalAmount:
            i &&
            i.original &&
            i.original.paid_amount &&
            i.original.paid_amount.value,
        };
      });
      return {
        ...state,
        selectedNsfInvoice: currentNsfInvoice, //selectedNsfInvoice    : currentNsfInvoice,
      };

    case GET_INVOICES:
      let invoices = payload.map((i) => {
        return {
          _id: i.original._id,
          invoiceCurrency: i.original.invoice_currency,
          invoiceTotalAmount:
            i &&
            i.original &&
            i.original.not_paid_amount &&
            i.original.not_paid_amount.value,
        };
      });

      return {
        ...state,
        invoices: invoices,
      };

    default:
      return state;
  }
};

export default invoiceReducer;
